export enum TokenSymbol {
  ETH = 'ETH',
  BNB = 'BNB',
  ANKR = 'COQ'
}

export enum ChainSymbol {
  ETH = 'ETH',
  BNB = 'BSC',
  ANKR = 'COQ',
}
